<template>
  <div>
    <p>{{ translate('flyover.feeds.schedules.tab.sort.label') }}</p>
    <mds-button
      icon-right="caret-down"
      size="small"
      variation="flat"
      :disabled="disableSortBy"
    >
      {{ translate('flyover.feeds.schedules.tab.mostRecent.button') }}
    </mds-button>
  </div>
</template>

<script>
import { MdsButton } from '@mds/button'
import MwcBaseHelpersMixin from '@morningstar/mcl-utilities/src/vue/mixins/mwc-base-mixin'
import defaultConfig from '../../config/i18n'

export default {
  name: 'SortByButton',
  components: {
    MdsButton,
  },
  mixins: [MwcBaseHelpersMixin],
  props: {
    disableSortBy: Boolean,
  },
  data() {
    return {
      defaultConfig,
    }
  },
}
</script>
